import type { UnitGroup } from "@/types";
/**
 * Take in array of units and remove units that don't match according to category id's
 */
export const filterUnitCategories = (
    units: UnitGroup[],
    categoryIds: number[],
) => {
    return units.filter((unit) => {
        // First, ensure the category is not null
        if (unit.representative_unit.category === null) return false;

        // If categoryIds is provided, check if the category id is included
        return (
            categoryIds.length === 0 ||
            categoryIds.includes(unit.representative_unit.category.id)
        );
    });
};

/**
 * Take in array of units and remove units that don't match according to feature id's
 */
export const filterUnitFeatures = (
    units: UnitGroup[],
    featureIds: number[],
) => {
    return featureIds.length > 0
        ? units.filter((unit) => {
              return featureIds.every((featureId) =>
                  unit.representative_unit.features.some(
                      (feature) => feature.id == featureId,
                  ),
              );
          })
        : units;
};

export const filterUnitsByFeatureCategory = (
    units: UnitGroup[],
    featureIds: number[],
    categoryIds: number[],
) => {
    const categoryFiltered = filterUnitCategories(units, categoryIds);

    return filterUnitFeatures(categoryFiltered, featureIds);
};
